import React, { createContext, useState, useContext, useEffect } from "react";
import { useAuth } from "./AuthContext";
import { getPortnousUrl } from "../../environment/BackendService";

const RBACContext = createContext();

export const RBACProvider = ({ children }) => {
  const [writeAccess, setRightAccess] = useState(true);
  const { AuthHeaders } = useAuth();
  const {
    ["tenant-id"]: modulename = "",
    ["business-object"]: businessObject = "",
    ["session-id"]: sessionId = "",
    ["auth-type"]: authtype = "",
  } = AuthHeaders;



  useEffect(() => {
    const setAccess = async () => {
      try {
        const response = await fetch(getPortnousUrl(), {
          method: "GET",
          headers: {modulename,authtype,['session-id']:sessionId },
        });
        const abilities = await response.json();
        const tenent = modulename.split("_")[0];
        const allAbilities = abilities.abilities["all-abilities"];

        const featureAbilities = allAbilities?.filter((ability) =>
          ability.includes(`${tenent}.${businessObject}`)
        );

        const access = featureAbilities.some((ability) =>
          ability.includes("access.grant")
        );

        setRightAccess(access);
      } catch (e) {
        console.error("unable to fetch abilities", e);
      }
    };
    setAccess();
  }, [modulename, businessObject]);
  return (
    <RBACContext.Provider value={{ writeAccess }}>
      {children}
    </RBACContext.Provider>
  );
};

export const useRBAC = () => useContext(RBACContext);